import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'ze-test-data-dialog',
  templateUrl: './test-data-dialog.component.html',
  styleUrls: ['./test-data-dialog.component.scss']
})
export class TestDataDialogComponent implements OnInit {
  formattedData: string = '';

  constructor(
    public dialogRef: MatDialogRef<TestDataDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { testData: any[], testCaseId: string }
  ) {
    this.formattedData = this.formatTestData(data.testData);
  }

  ngOnInit(): void {
  }

  formatTestData(testData: any[]): string {
    if (!testData || !Array.isArray(testData) || testData.length === 0) {
      return 'No test data available';
    }

    const formatted: string[] = [];
    testData.forEach(item => {
      if (item && typeof item === 'object') {
        Object.keys(item).forEach(key => {
          formatted.push(`${key} = ${item[key]}`);
        });
      }
    });

    return formatted.join('\n');
  }

  onClose(): void {
    this.dialogRef.close();
  }
}

